export default __webpack_public_path__ + "static/media/vasthav.4313ba68.jpg";